export default "__VITE_ASSET___ed1cfB1__"